import api from './api'
import type { UserProfile } from './auth'

export interface ImpersonationSession {
  access_token: string
  refresh_token: string
  user: UserProfile
}

export interface StartImpersonationResponse {
  access_token: string
  expires_at: number
  audit_log_id: string
  user: UserProfile
}

const STASH_KEY = 'impersonator_session'
const AUDIT_KEY = 'impersonation_audit_id'
const EXPIRES_KEY = 'impersonation_expires_at'

export async function startImpersonation(
  targetUserId: string | null,
  targetEmail: string | null,
  reason?: string
): Promise<StartImpersonationResponse> {
  const response = await api.post<StartImpersonationResponse>('/master/impersonate/start', {
    targetUserId,
    targetEmail,
    reason
  })
  return response.data
}

export async function stopImpersonationApi(audit_log_id: string): Promise<void> {
  await api.post('/auth/impersonate/stop', { audit_log_id })
}

export async function fetchImpersonationHistory(): Promise<any[]> {
  const response = await api.get<{ items: any[] }>('/master/impersonate/history')
  return response.data.items
}

export function stashAdminSession(session: ImpersonationSession) {
  localStorage.setItem(STASH_KEY, JSON.stringify(session))
}

export function popAdminSession(): ImpersonationSession | null {
  const raw = localStorage.getItem(STASH_KEY)
  if (!raw) return null
  localStorage.removeItem(STASH_KEY)
  try {
    return JSON.parse(raw)
  } catch {
    return null
  }
}

export function setImpersonationMeta(auditLogId: string, expiresAt: number) {
  localStorage.setItem(AUDIT_KEY, auditLogId)
  localStorage.setItem(EXPIRES_KEY, String(expiresAt))
}

export function getImpersonationMeta(): { auditLogId: string; expiresAt: number } | null {
  const auditLogId = localStorage.getItem(AUDIT_KEY)
  const expiresAtRaw = localStorage.getItem(EXPIRES_KEY)
  if (!auditLogId || !expiresAtRaw) return null
  return { auditLogId, expiresAt: parseInt(expiresAtRaw, 10) }
}

export function clearImpersonationMeta() {
  localStorage.removeItem(AUDIT_KEY)
  localStorage.removeItem(EXPIRES_KEY)
}

export function isImpersonating(): boolean {
  return !!localStorage.getItem(AUDIT_KEY)
}
